import {QuestionModel} from '../question.model';
import {ImageCategoryTypes} from '../shared/imageType.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class MeasurementInputModel extends QuestionExtendedModel {

  majorVersion = 1;
  minorVersion = 8;
  revisionVersion = 1;

  model: {
    metricType: string,
    imageCategory: string,
    isDualInput: Boolean,
    metricSystem: {
      baseUnit: string,
      list: { value: number, image: string }[]
    },
    usCustomarySystem: {
      baseUnit: string,
      list: { value: number, image: string }[]
    }
  } = {
    metricType: Enums.Metrics.length,
    imageCategory: ImageCategoryTypes.monsters,
    isDualInput: true,
    metricSystem: {
      baseUnit: Enums.MetricLengths.cm,
      list: []
    },
    usCustomarySystem: {
      baseUnit: Enums.USCustomaryLengths.in,
      list: []
    }
  };

  static generateModel(json: any): MeasurementInputModel {

    const q = new MeasurementInputModel();

    const model = json.model;
    if (model) {

      q.model.metricType = model.metricType;
      q.model.imageCategory = model.imageCategory;
      q.model.isDualInput = model.isDualInput;

      q.model.metricSystem = model.metricSystem;
      q.model.usCustomarySystem = model.usCustomarySystem;

    }

    return q;

  }

}
